import afriexWhiteLogo from '@/assets/svg/afriex-new-logo-white.png';

import receiptConfig from './config';

export const ReceiptFooter = () => {
  return (
    <>
      {/* Refund Policy */}
      <div className="mx-7">
        <div>
          <p className="text-cyan-600 font-medium text-xs mb-2 my-2">
            {receiptConfig.refundPolicyTitle}
          </p>
          <hr className="border-receipt-line dark:border-dark-borderMid" />

          <p
            className="text-xs font-medium text-receipt-policy mt-4 leading-relaxed my-4 text-justify"
            dangerouslySetInnerHTML={{
              __html: receiptConfig.refundPolicyContent,
            }}
          />
        </div>
      </div>

      <footer className="w-full bg-cyan-600 p-7 h-40 rounded-b-md">
        <div className="logoCon items-center flex gap-1 w-50 mb-3">
          <div id="logoPng" className="logoSvg">
            <img src={afriexWhiteLogo} alt="Afriex Logo" />
          </div>
        </div>
        <hr className="border-white dark:border-dark-borderLight" />
      </footer>
    </>
  );
};
